import { hasUserRejectedTxnApprove, signAndSendTxns } from './helpers';
import { chunk } from 'lodash';
export const DEFAULT_EXECUTOR_OPTIONS = {
    commitment: 'confirmed',
    signAllChunks: 40,
    skipPreflight: false,
    preflightCommitment: 'processed',
    rejectQueueOnFirstPfError: false,
    chunkCallOfActionFn: true,
    parallelExecutionTimeot: 0,
    preventTxnsSending: false,
};
export class TxnExecutor {
    makeActionFn;
    txnsParams = [];
    options = DEFAULT_EXECUTOR_OPTIONS;
    walletAndConnection;
    eventHandlers = {};
    constructor(makeActionFn, walletAndConnection, options) {
        this.makeActionFn = makeActionFn;
        this.walletAndConnection = walletAndConnection;
        this.options = {
            ...this.options,
            ...options,
        };
    }
    addTxnParam(param) {
        this.txnsParams = [...this.txnsParams, param];
        return this;
    }
    addTxnParams(params) {
        this.txnsParams = [...this.txnsParams, ...params];
        return this;
    }
    on(type, handler) {
        this.eventHandlers = {
            ...this.eventHandlers,
            [type]: handler,
        };
        return this;
    }
    async execute() {
        if (this.options.chunkCallOfActionFn) {
            return await this.executeChunked();
        }
        return await this.executeDefault();
    }
    async executeDefault() {
        try {
            const { txnsParams, makeActionFn, walletAndConnection, options, eventHandlers } = this;
            const txnsData = await Promise.all(txnsParams.map((params) => makeActionFn(params, { ...walletAndConnection })));
            eventHandlers?.beforeFirstApprove?.();
            const txnChunks = chunk(txnsData, options.signAllChunks);
            const signAndSendTxnsResults = [];
            for (const chunk of txnChunks) {
                try {
                    const result = await signAndSendTxns({
                        txnsData: chunk,
                        walletAndConnection,
                        eventHandlers,
                        options,
                    });
                    signAndSendTxnsResults.push(...result);
                }
                catch (error) {
                    eventHandlers?.pfError?.(error);
                    const userRejectedTxn = hasUserRejectedTxnApprove(error);
                    if (userRejectedTxn)
                        return;
                    if (!userRejectedTxn && options.rejectQueueOnFirstPfError)
                        return;
                }
            }
            if (signAndSendTxnsResults.length === txnChunks.flat().length) {
                eventHandlers?.pfSuccessAll?.(signAndSendTxnsResults);
            }
            else if (signAndSendTxnsResults.length) {
                eventHandlers?.pfSuccessSome?.(signAndSendTxnsResults);
            }
            return signAndSendTxnsResults;
        }
        catch (error) {
            this.eventHandlers?.pfError?.(error);
        }
    }
    async executeChunked() {
        try {
            const { txnsParams, makeActionFn, walletAndConnection, options, eventHandlers } = this;
            const txnsDataChunks = chunk(txnsParams, options.signAllChunks);
            eventHandlers?.beforeFirstApprove?.();
            const signAndSendTxnsResults = [];
            for (const chunk of txnsDataChunks) {
                try {
                    const txnsData = await Promise.all(chunk.map((params) => makeActionFn(params, { ...walletAndConnection })));
                    const result = await signAndSendTxns({
                        txnsData,
                        walletAndConnection,
                        eventHandlers,
                        options,
                    });
                    signAndSendTxnsResults.push(...result);
                }
                catch (error) {
                    eventHandlers?.pfError?.(error);
                    const userRejectedTxn = hasUserRejectedTxnApprove(error);
                    if (userRejectedTxn)
                        return;
                    if (!userRejectedTxn && options.rejectQueueOnFirstPfError)
                        return;
                }
            }
            if (signAndSendTxnsResults.length === txnsDataChunks.flat().length) {
                eventHandlers?.pfSuccessAll?.(signAndSendTxnsResults);
            }
            if (signAndSendTxnsResults.length) {
                eventHandlers?.pfSuccessSome?.(signAndSendTxnsResults);
            }
            return signAndSendTxnsResults;
        }
        catch (error) {
            this.eventHandlers?.pfError?.(error);
        }
    }
}
